import styled from "styled-components";

export const Title = styled.p`
  color: ${({ theme, primary }) => (primary ? primary : theme.text)};
  font-size: ${({ size }) => size};
  margin: ${({ space }) => space};
  text-align: ${({ align }) => align};
  font-weight: ${({ weight }) => weight};
  white-space: ${({ pre }) => (pre ? "pre-wrap" : "unset")};
  transition: all 0.4s ease-in-out;
  &:hover {
    ${({ hover }) => hover};
  }
  display: ${({ isOpenSubMenu }) => (isOpenSubMenu ? "none" : "block")};
  animation: name-of-animation 0.5s;
  @keyframes name-of-animation {
    0% {
      opacity: 0;
    }
    20% {
      opacity: 0.25;
    }
    80% {
      opacity: 0.7;
    }
    100% {
      opacity: 1;
    }
  }
  @media (max-width: 1200px) {
    font-size: ${({ lgsize }) => lgsize};
  }
  @media (max-width: 991px) {
    font-size: ${({ mdsize }) => mdsize};
  }
`;
